export const META_TYPE = 'simpleTickers';
export const META_VER = 'v1';

export const CMD_TICKER_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
